import { ValueOf } from './value-of';

export const INVENTORY_CONDITION = {
  NEAR_MINT: 'near_mint',
  SLIGHTLY_PLAYED: 'slightly_played',
  MODERATELY_PLAYED: 'moderately_played',
  HIGHLY_PLAYED: 'highly_played',
  DAMAGED: 'damaged',
} as const;

export type InventoryCondition = ValueOf<typeof INVENTORY_CONDITION>;

export const INVENTORY_CONDITION_LABELS: Record<InventoryCondition, string> = {
  near_mint: 'Quase nova',
  slightly_played: 'Pouco jogada',
  moderately_played: 'Moderadamente jogada',
  highly_played: 'Muito jogada',
  damaged: 'Danificada',
};

export const INVENTORY_CONDITION_COLORS: Record<InventoryCondition, string> = {
  near_mint: 'green',
  slightly_played: 'cyan',
  moderately_played: 'gold',
  highly_played: 'orange',
  damaged: 'red',
};

export const INVENTORY_CONDITION_CODE: Record<InventoryCondition, string> = {
  near_mint: 'NM',
  slightly_played: 'SP',
  moderately_played: 'MP',
  highly_played: 'HP',
  damaged: 'DM',
};

export const INVENTORY_EDITION = {
  FIRST_EDITION: 'first_edition',
  LIMITED_EDITION: 'limited_edition',
  UNLIMITED_EDITION: 'unlimited_edition',
} as const;

export type InventoryEdition = ValueOf<typeof INVENTORY_EDITION>;

export const INVENTORY_EDITION_LABELS: Record<InventoryEdition, string> = {
  first_edition: '1ª edição',
  limited_edition: 'Edição limitada',
  unlimited_edition: 'Edição ilimitada',
};

export const getInventoryEditionLabel = (edition?: InventoryEdition | null) =>
  edition ? INVENTORY_EDITION_LABELS[edition] : 'Sem edição informada';

export interface LanguageInfo {
  name: string;
  code: string;
}

export interface Language extends LanguageInfo {
  id: string;
}
